// 9fbef606107a605d69c0edbcd8029e5d
import { useRef } from 'react';
import { formatCreditCardNumber } from './formatUtils';

const useCreditCardNumber = ({ input }) => {
  const cardNumberField = useRef();
  const { onChange, ...otherInputProps } = input;

  const formatOnChange = (e) => {
    const value = formatCreditCardNumber(e.target.value);

    cardNumberField.current.value = value;

    // eslint-disable-next-line no-unused-expressions
    onChange && onChange(e);
  };

  return [
    cardNumberField,
    {
      ...otherInputProps,
      onChange: formatOnChange,
    },
  ];
};

export default useCreditCardNumber;
